import type { SVGProps } from 'react'

const SvgShiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread props to allow customization
  >
    <path
      d="M9.452 12.5865V5.4135L13.048 9L9.452 12.5865ZM15.6923 17.5C16.1909 17.5 16.6169 17.3234 16.9702 16.9703C17.3234 16.6169 17.5 16.1909 17.5 15.6923V2.30775C17.5 1.80908 17.3234 1.38308 16.9702 1.02975C16.6169 0.676583 16.1909 0.5 15.6923 0.5H2.30775C1.80908 0.5 1.38308 0.676583 1.02975 1.02975C0.676582 1.38308 0.5 1.80908 0.5 2.30775V15.6923C0.5 16.1909 0.676582 16.6169 1.02975 16.9703C1.38308 17.3234 1.80908 17.5 2.30775 17.5H15.6923ZM6.5 16V2H15.6923C15.7693 2 15.8397 2.03208 15.9037 2.09625C15.9679 2.16025 16 2.23075 16 2.30775V15.6923C16 15.7692 15.9679 15.8398 15.9037 15.9038C15.8397 15.9679 15.7693 16 15.6923 16H6.5Z"
      fill="#757575"
    />
  </svg>
)

export default SvgShiftIcon
